import Backbone from 'backbone';
import { isEmpty } from 'underscore';
import templatesListModel from '../model/templatesList';
import templatesListview from './templatesListView';
import categoryModel from '../model/groups';
import categoriesView from './categoriesView';
var sourceFile = require('../../../config/config.js');
const url = sourceFile.url;
const rootDir = sourceFile.rootDir;

export default Backbone.View.extend({
  initialize(o) {
    this.templateListData = this.formatData(o.modelData.template_list);
    let groupsData = this.formatData(o.modelData.groups);
    this.groupsData = isEmpty(groupsData) ? [] : groupsData[0].data;
    this.categoryView = new categoriesView({
      collection: new categoryModel(
        [{ id: '', name: 'All', is_selected: true }].concat(this.groupsData)
      ),
      parent: this
    });
    this.categoryView.on('categorySelected', this.loadTemplates, this);
    this.render();
  },
  render() {
    let markup = this.template();
    this.$el.html(markup);
    this.$el.find('.panel').append(this.categoryView.render().$el);
  },

  loadTemplates(id) {
    if (this.templatesList) {
      this.templatesList.remove();
    }
    if (id) {
      let templatelist = this.templateListData.filter(function(template) {
        if (template.group == id) {
          return template;
        }
      });
      this.setTemplateListView(templatelist);
    } else {
      this.setTemplateListView(this.templateListData);
    }
    this.$el.find('.body-content').append(this.templatesList.render().$el);
  },

  setTemplateListView(templateList) {
    this.templatesList = new templatesListview({
      collection: new templatesListModel(templateList),
      parent: this,
      groups: this.groupsData
    });
    this.$el.find('.number-of-templates').text(templateList.length);
  },
  formatData(data) {
    if (!isEmpty(data)) {
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
    }
    return data;
  },
  template() {
    return `
        <div class="marketplace-palette">
          <div class="palette-header">
              <div class="primary-header">
                  <div class="primary-header-content">
                      <div class="image">
                          <img src="${url}/app/src/images/studio.svg">
                      </div>
                      <div class="text">Marketplace</div>
                  </div>

              </div>
              <div class="secondary-header">
                  <div class="content">
                      <div class="search-box">
                          <img src="${url}/static/images/Search%20icon.svg">
                          <input placeholder="Search template" class="serach-text" type="text">
                      </div>
                      <div class="close-button">
                          <img src="${rootDir}/assets/images/close.svg">
                      </div>
                      <div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="palette-body">
              <div class="body-panel">
                  <div class="panel">
                      <div class="panel-item panel-header">Categories</div>
                  </div>
              </div>
              <div class="body-content">
                  <div class="content-header">
                      <span class="number-of-templates">20</span> Templates
                  </div>
              </div>
          </div>
      </div>
    `;
  },
  events: {
    'click .secondary-header .close-button': 'closeModal'
  },
  closeModal() {
    this.remove();
  }
});
